// Global Variables for urls. These should be modified for the specific environment.
export const getCommonDomain = url => {
  if (url.toLowerCase().indexOf('edwardjones.com') !== -1) {
    return 'edwardjones.com';
  }
  return 'devjones.com';
};
export const COMMON_DOMAIN = getCommonDomain(window.location.href);
export const URL_UMS_REDIRECT = url => `http://userutilityweb.${getCommonDomain(url)}:9007/FWKurl-mapping-web/forward-url-map-entry.action`;
export const URL_REL_WKSPC = url => `http://relworkspaceweb.${getCommonDomain(url)}:9048/RLWRelationshipWorkspace-web/display-workspace.action`;
export const URL_PREFS_WKSPC = url => `http://userutilityweb.${getCommonDomain(url)}:9007/PRFpreferencesworkspace-web/display-preferences-workspace.action`;
export const URL_WEBDIAL = url => `http://supportsvcweb.${getCommonDomain(url)}:9001/WDLwebdial-web/webdial-screen.action`;
export const GENERIC_WINDOW_NAME = 'GenericWin';
export const TRAN_ID_PREFIX = 'ejt';
//# sourceMappingURL=url-consts.js.map